import { getSignalTranslation } from '@/helpers';
import { RiskType } from '@/models';
import styles from './RiskDetailsTagInfoItem.module.sass';

interface RiskDetailsTagInfoItemProps {
  label: string;
  type?: RiskType;
}

const RiskDetailsTagInfoItem = ({ label }: RiskDetailsTagInfoItemProps) => {
  const displayLabel = getSignalTranslation(label);

  return (
    <div className={styles.item}>
      <div className={styles.title}>{displayLabel}</div>
    </div>
  );
};

export default RiskDetailsTagInfoItem;
